export default {
  ENTER_KEYCODE: 13,
  RIGHT_CLICK_TRIGGER_ID: 'right-click',

  DIALOG_APPEARANCE: 'dialog',
  DIALOG_BLOCK_APPEARANCE: 'dialog-block',
  APP_ELEMENT_SELECTOR: '#app',
};
